import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { websites: Array }
  static targets = ["input", "results"]

  connect() {
    this.timeout = null
    this.selectedIndex = -1
    document.addEventListener('click', this.handleClickOutside)
    console.log('Brand checker connected. Websites:', this.websitesValue)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  filterWebsites(event) {
    const query = event.target.value.trim()
    console.log('Filtering websites with query:', query)

    if (!query) {
      this.hideResults()
      return
    }

    // Debounce the filtering
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.performFilter(query)
    }, 150)
  }

  performFilter(query) {
    this.filteredWebsites = this.websitesValue.filter(website =>
      website.toLowerCase().includes(query.toLowerCase())
    )
    this.selectedIndex = -1 // Reset selection when filtering
    console.log('Filtered results:', this.filteredWebsites)

    this.showResults(this.filteredWebsites)
  }

  showResults(websites) {
    if (websites.length === 0) {
      this.hideResults()
      return
    }

    const resultsHtml = websites
      .slice(0, 5) // Limit to 5 results
      .map((website, index) => `
        <div class="px-3 py-2 cursor-pointer border-b border-gray-100 last:border-b-0 autocomplete-item"
             data-action="click->brand-checker#selectWebsite"
             data-website="${website}"
             data-index="${index}">
          <div class="text-sm text-gray-900">${website}</div>
        </div>
      `).join('')

    this.resultsTarget.innerHTML = `
      <div class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
        ${resultsHtml}
      </div>
    `

    this.updateSelection()
  }

  selectWebsite(event) {
    const website = event.currentTarget.dataset.website
    this.inputTarget.value = website
    this.hideResults()

    // Trigger change event to update form
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  hideResults() {
    this.resultsTarget.innerHTML = ''
    this.selectedIndex = -1
  }

  handleKeydown(event) {
    if (!this.filteredWebsites || this.filteredWebsites.length === 0) return

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        this.selectedIndex = Math.min(this.selectedIndex + 1, Math.min(this.filteredWebsites.length - 1, 4)) // Max 5 items
        this.updateSelection()
        break
      case 'ArrowUp':
        event.preventDefault()
        this.selectedIndex = Math.max(this.selectedIndex - 1, -1)
        this.updateSelection()
        break
      case 'Enter':
        event.preventDefault()
        if (this.selectedIndex >= 0 && this.selectedIndex < this.filteredWebsites.length) {
          this.selectWebsiteByIndex(this.selectedIndex)
        }
        break
      case 'Escape':
        event.preventDefault()
        this.hideResults()
        break
    }
  }

  updateSelection() {
    const items = this.resultsTarget.querySelectorAll('.autocomplete-item')
    items.forEach((item, index) => {
      if (index === this.selectedIndex) {
        item.classList.add('bg-indigo-50', 'text-indigo-900')
        item.classList.remove('hover:bg-gray-50')
      } else {
        item.classList.remove('bg-indigo-50', 'text-indigo-900')
        item.classList.add('hover:bg-gray-50')
      }
    })
  }

  selectWebsiteByIndex(index) {
    if (this.filteredWebsites && this.filteredWebsites[index]) {
      this.inputTarget.value = this.filteredWebsites[index]
      this.hideResults()

      // Trigger change event to update form
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
